<template>
    <div>
        <v-container>
            <v-row>
                <v-col>
                    <span class="national-light uppercase d-none d-md-inline" style="font-size: 50px; letter-spacing: 2px;">{{designer.name}}</span>

                    <span class="national-bold uppercase d-md-none" style="font-size: 50px; letter-spacing: 2px;">{{designer.name}}</span>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12" offset-md="1" md="3">
                    <span class="national-bold uppercase" style="letter-spacing: 2px">{{designer.title1}}</span>
                    <div v-html="designer.details">

                    </div>
                </v-col>
                <v-col cols="12" offset-md="1" md="3">
                    <span class="national-bold uppercase" style="letter-spacing: 2px">{{designer.title2}}</span>
                    <div v-html="designer.credits">

                    </div>
                    
                </v-col>
            </v-row>

            <v-row>
                <v-col offset-md="1">
                    <template v-if="collaborator">
                        <template v-if="designer.collaborator != null">
                            <v-img :src="'https://artlesscms.actstudio.xyz/'+designer.collaborator.path" width="150"></v-img>
                        </template>
                    </template>
                    <template v-if="collaborator2">
                        <template v-if="designer.collaborator2 != null">
                            <v-img :src="'https://artlesscms.actstudio.xyz/'+designer.collaborator2.path" width="150"></v-img>
                        </template>
                    </template>
                </v-col>
            </v-row>

            <v-row v-if="loaded">
                <v-col>
                    <div class="owl-carousel-custom" style="position: relative; overflow: hidden">
                        <template>
                            <carousel :autoplay="false" :nav="false" :items="2" :dots="false" :responsive="{0:{items:1},600:{items:2}}">
                                <template v-for="(image,n) in designer.gallery">
                                    <img :src="'https://artlesscms.actstudio.xyz/'+image.path" :key="'nnnn'+n">
                                </template>

                                <template slot="prev">
                                    <span class="prev-icon"><v-icon size="36" color="#221F1F">mdi-chevron-left</v-icon></span>
                                </template>

                                <template slot="next">
                                    <span class="next-icon"><v-icon size="36" color="#221F1F">mdi-chevron-right</v-icon></span>
                                </template>
                            </carousel>
                        </template>
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import carousel from 'vue-owl-carousel'
export default {
    components: { carousel },
    data(){
        return {
            designer: {
                collaborator:{
                    path: null
                },
                collaborator2:{
                    path: null
                },
            },
            loaded: false
        }
    },
    beforeMount: function () {
        var aux = this;
        fetch(
            "https://www.artlesscms.actstudio.xyz/api/collections/get/Designers?token=a15be93e9cdb43ca2b3778c2077c26",
            {
                method: "post",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    filter: {
                        url: this.$route.params.url
                    },
                })
            }
        )
        .then(res => res.json())
        .then(res => (this.designer = res.entries[0]))
        .then(()=>(this.loaded = true))
        .then(()=>{
            var breadcrumbs = [
                // {
                //     text: 'Home',
                //     link: '/',
                //     isLink: true
                // },
                {
                    text: 'Custom',
                    link: '/custom',
                    isLink: true
                },
                {
                    text: 'Clients',
                    link: '/custom/designers',
                    isLink: true
                },
                {
                    text: this.designer.name,
                    link: '',
                    isLink: false
                }
            ];
            this.$emit("updateStatus", breadcrumbs);
        });
    },
    mounted() {
        var breadcrumbs = [
            {
                text: 'Home',
                link: '/',
                isLink: true
            },
            {
                text: 'Custom',
                link: '/custom',
                isLink: true
            },
            {
                text: 'Designers',
                link: '/custom/designers',
                isLink: true
            }
        ];
        this.$emit("updateStatus", breadcrumbs);
        this.$emit("update", 2);

        var aux = this;
        gtag('config', 'UA-26953667-1', {
        'page_title' : 'Custom Designer '+aux.$route.params.url,
        'page_path': '/custom/designer/'+aux.$route.params.url
        });
    },
    methods:{
    },
    computed:{
        collaborator: function(){
            if(this.designer.collaborator == undefined){
                return false;
            }
            return true;
        },
        collaborator2: function(){
            if(this.designer.collaborator2 == undefined){
                return false;
            }
            return true;
        }
    }
}
</script>